export class ActorDto {
  constructor(name, username, email) {
    this.name = name
    this.username = username
    this.email = email
  }
}
